/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ThemeEnum } from "./ThemeEnum";

export interface Contexts {
  theme?: ThemeEnum | null;
  utm_term?: string | null;
}
